module.exports = __webpack_public_path__ + "img/depmap_svg_V186.95b2e3ae.svg";